module.exports = __webpack_public_path__ + "static/img/menage6.40bba9a5.png";